import Complete from './Complete';

export default {
  title: 'Certificate',
  children: [
    Complete
  ]
};



// WEBPACK FOOTER //
// ./src/data/certificate/index.js